/**
 * @params{number} time 延迟秒数
 */
export function sleep(time) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve()
        }, time * 1000)
    })
}

export const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

export const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1

export const isAPP = /LILYTribe/g.test(navigator.userAgent)